/**
 * @generated SignedSource<<2e433d4130d621e20d72d0890b193ffc>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type AutoShareToChannelsAddChannelMutation$variables = {
  channelId: string;
  streamId: string;
};
export type AutoShareToChannelsAddChannelMutation$data = {
  readonly streamAutoShareSettingsAddChannel: {
    readonly streamAutoShareSettings: {
      readonly channels: ReadonlyArray<{
        readonly id: string;
        readonly isPrivate: boolean;
        readonly name: string;
      }>;
    };
  } | null;
};
export type AutoShareToChannelsAddChannelMutation = {
  response: AutoShareToChannelsAddChannelMutation$data;
  variables: AutoShareToChannelsAddChannelMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "channelId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "streamId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "channelId",
    "variableName": "channelId"
  },
  {
    "kind": "Variable",
    "name": "streamId",
    "variableName": "streamId"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isPrivate",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AutoShareToChannelsAddChannelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StreamAutoShareSettingsAddChannel",
        "kind": "LinkedField",
        "name": "streamAutoShareSettingsAddChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StreamAutoShareSettings",
            "kind": "LinkedField",
            "name": "streamAutoShareSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "channels",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "AutoShareToChannelsAddChannelMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "StreamAutoShareSettingsAddChannel",
        "kind": "LinkedField",
        "name": "streamAutoShareSettingsAddChannel",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "StreamAutoShareSettings",
            "kind": "LinkedField",
            "name": "streamAutoShareSettings",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "channels",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  },
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "b404704084a355ffe71bd5b0eb72bf2c",
    "id": null,
    "metadata": {},
    "name": "AutoShareToChannelsAddChannelMutation",
    "operationKind": "mutation",
    "text": "mutation AutoShareToChannelsAddChannelMutation(\n  $streamId: ID!\n  $channelId: ID!\n) {\n  streamAutoShareSettingsAddChannel(streamId: $streamId, channelId: $channelId) {\n    streamAutoShareSettings {\n      channels {\n        __typename\n        id\n        name\n        isPrivate\n      }\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "25326aed8f13c54e1cf08f7aab90259e";

export default node;
